import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiteSocialsComponent } from '@core/components/site-socials/site-socials.component';

import { ChatRoomComponent } from './chat-room/chat-room.component';
import { ChatSoundComponent } from './chat-sound/chat-sound.component';
import { ChatSendMessageComponent } from './chat-send-message/chat-send-message.component';
import { ChatService } from './services/chat.service';
import { ChatMessagesComponent } from './chat-messages/chat-messages.component';
import { TriviaService } from '@features/trivia/trivia.service';
import { TriviaRegularWidgetComponent } from '@features/trivia/trivia-regular-widget/trivia-regular-widget.component';
import { TriviaRainWidgetComponent } from '@features/trivia/trivia-rain-widget/trivia-rain-widget.component';
import { ChatHeaderFeaturesComponent } from './chat-header-features/chat-header-features.component';
import { SoundsService } from '@core/services/sounds.service';
import { SupplyDropWidgetComponent } from "@features/supply-drop/supply-drop-widget/supply-drop-widget.component";
import { SupplyDropService } from '@features/supply-drop/supply-drop.service';
import { RainWidgetComponent } from "@features/rain/rain-widget/rain-widget.component";
import { RainService } from '@features/rain/rain.service';
import { ChatPinnedMessageComponent } from '@features/pinned-message/pinned-message-widget/pinned-message-widget.component';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SiteSocialsComponent,
    ChatRoomComponent,
    ChatSoundComponent,
    ChatSendMessageComponent,
    ChatMessagesComponent,
    TriviaRegularWidgetComponent,
    TriviaRainWidgetComponent,
    ChatHeaderFeaturesComponent,
    SupplyDropWidgetComponent,
    RainWidgetComponent,
    ChatPinnedMessageComponent,
],
  host: {
    class: 'flex flex-col',
  },
})
export class ChatComponent {
  constructor(
    public chatService: ChatService,
    public soundsService: SoundsService,
    public triviaService: TriviaService,
    public supplyDropService: SupplyDropService,
    public rainService: RainService,
    public sessionService: SessionService
  ) {}
}
